

<template>
  <body leftmargin="0" topmargin="0" style="overflow-x:hidden;">
<div class="reuters_popup">
  <div class="reuters_header_wrap">
    <div class="reuters_header">
      <a href="http://www.carrotenglish.com" target="_blank"><h1></h1></a>
      <a href="javascript:window.close();" class="close"><img src="@/assets/img/pop_close.png" border="0"/></a>
    </div>
  </div>
  <div class="popup_reuters">
    <div class="popup_reuters_wrap">

      <div class="info">
        <ul class="m_logo">
          <li class="m_logo_carrot"></li>
          <a href="http://247news.co.kr/" target="_blank">
            <li class="m_logo_reuters"></li>
          </a>
        </ul>
        <h2 class="code_reuter">로이터 컨텐츠</h2>
        <p class="title_underline"></p>
        <h3>{{ news.engTitle }}</h3>
        <h4>{{ news.korTitle }}</h4>
        <p class="info_download info_btn">
        </p>
      </div>
      <div class="reuters">
        <!-- 동영상 시작-->
        <div v-if="agent === 'pc'" style="text-align: center" class="video_wrapper">

          <!-- //20200520 아일린님 요청 우클릭 방지 -->
          <video id="web_video" :src= "newsUrl" controls style=" width:90% !important;height:340px;object-fit: fill;background-size:cover" oncontextmenu='return false' controlsList="nodownload">
            <!-- <source  type= "video/mp4" id="player<?=$i?>">  -->
          </video>
        </div>

        <video v-if="agent === 'Android' || agent === 'ios'" id="web_video" :src= "newsUrl" controls autoplay  width= "100%" >
          <!-- <source  type= "video/mp4"   src= "<?=$news?>" id="player<?=$i?>">  -->
        </video>
        <!-- 동영상 종료-->
      </div>
    </div>
  </div>

  <div class="pop_cont" id="content_tab_01" v-if="pageNum === 1">
    <div class="pop_cont_title">
      <ul>
        <li class="prev"><a onclick="window.open('/cafe/guide_new','powerguide','width=950,height=600'); void(0);" style="font-size: 11px; text-decoration: underline; margin: 0 10px 0 0; cursor: pointer; padding: 10px 0 0 0;"><span>학습가이드 보기</span></a></li>
        <li class="navi"><span class="on"></span><span class="off"></span><span class="off"></span><span class="off"></span></li>
        <li class="next"><a style="cursor: pointer;" @click="goPage('next')"><img src="@/assets/img/study_btn_next.png" alt="" border="0"/></a></li>
      </ul>
    </div>
    <div class="pop_key">
      <ul class="pop_key_nav" style="vertical-align: bottom">
        <li :class="{'tab on': tabType === 'exp', 'tab': tabType !== 'exp'}" style="cursor: pointer"  @click="tabType = 'exp'"><a>Key Expressions</a></li>
        <li :class="{'tab on': tabType === 'voc', 'tab': tabType !== 'voc'}" style="cursor: pointer" @click="tabType = 'voc'"><a>Key Vocabulary</a></li>
      </ul>
      <ul v-if="tabType === 'exp'" class="pop_key_contttt" id="key_expressions">
        <p class="pick">※ 아래 <span style="color: #FF0000;">P!ck</span> 버튼을 클릭하여 다양한 영상의 큐레이션을 학습해 보세요.</p>
        <li v-for="(item, index) of expressions" :key="index">
          <div>
            <h5>{{ item.EXPRESSIONS }} <span>{{ item.KOR_TITLE }}</span></h5>
            <a style="cursor: pointer"  @click="playtts( item.EXPRESSIONS)">
              <img src="@/assets/img/study_key_listen.png" alt="" border="0"/>
            </a>
            <a href="#" style="margin-left: 10px;" @click="doPick(item.EXPRESSIONS, item.KOR_TITLE )">
              <img src="@/assets/img/pick_btn.png" alt="" border="0"/>
            </a>
            <br/>
            <div v-html="item.CONTENT"></div>
          </div>
        </li>
      </ul>

      <ul v-if="tabType === 'voc'" class="pop_key_contttt" id="key_vocabulary" >
        <li v-for="(item, index) of vocabulary" :key="index">
          <div>
            <h5>{{ item.WORD }} <span>{{ item.TITLE }}</span></h5>
            <a style="cursor: pointer" @click="playtts(item.WORD)">
              <img src="@/assets/img/study_key_listen.png" alt="" border="0"/>
            </a>
            <br/>
            <div v-html="item.CONTENT"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
  <div class="pop_cont" id="content_tab_02" v-if="pageNum === 2">
    <div class="pop_cont_title">
      <ul>
        <li class="prev"><a style="cursor: pointer;" @click="goPage('prev');"><img src="@/assets/img/study_btn_prev.png" alt="" border="0"/></a></li>
        <li class="navi"><span class="on"></span><span class="off"></span><span class="off"></span><span class="off"></span><span v-if="is_discussion == 1" class="off"></span></li>
        <li class="next"><a style="cursor: pointer;" @click="goPage('next');"><img src="@/assets/img/study_btn_next.png" alt="" border="0"/></a></li>
      </ul>
    </div>
    <div class="pop_title" style="line-height:22px">
      <p>Listening & Shadowing <span><a onclick="window.open('/cafe/guide_snew','powerguide','width=950,height=500'); void(0);" target="_blank" style="cursor:pointer;"><!--<i class="fas fa-info-circle"></i>--><img src="@/assets/img/infor.png" alt="infor" border="0"></a></span></p>
      가급적 Script를 보지 마시고 원어민 음성에 집중해서 들으며 shadowing 해보세요. 효과가 확실합니다!<br/><span style="font-size:12px">(단어 뜻이나 해석은 신경 쓰지 않아야 합니다.) </span>
    </div>
    <div class="pop_quiz">
      <p class="pop_quiz_script" id="script_quiz" v-html="shadowDic">
      </p>
    </div>
</div>
  <div class="pop_cont" id="content_tab_03" v-if="pageNum === 3">
    <div class="pop_cont_title">
      <ul>
        <li class="prev"><a style="cursor: pointer;" @click="goPage('prev');"><img src="@/assets/img/study_btn_prev.png" alt="" border="0"/></a></li>
        <li class="navi"><span class="off"></span><span class="on"></span><span class="off"></span><span class="off"></span><span v-if="is_discussion == 1" class="off"></span></li>
        <li class="next "><a style="cursor: pointer;" @click="goPage('next');"><img src="@/assets/img/study_btn_next.png" alt="" border="0"/></a></li>
      </ul>
    </div>
    <div class="pop_title">
      <p>Dictation </p>
      동영상 뉴스를 들으면서 아래의 빈칸을 채워보세요.<br/>
      실력이 쑥쑥! 자, 그럼 Dictating을  시작해 볼까요?
    </div>
    <div class="pop_quiz">
      <p id="target_dic1" v-html="dictation">

      </p>
      <ul class="pop_quiz_btn">
        <a @click="goAnswer(2)" class="btn_re" style="cursor: pointer">다시풀기</a>
        <a @click="goAnswer(1)" class="btn_dictate" style="cursor: pointer">정답보기</a>
      </ul>
    </div>
  </div>
  <div class="pop_cont" id="content_tab_04" v-if="pageNum === 4">
    <div class="pop_cont_title">
      <ul>
        <li class="prev"><a style="cursor: pointer;" @click="goPage('prev');"><img src="@/assets/img/study_btn_prev.png" alt="" border="0"/></a></li>
        <li class="navi"><span class="off"></span><span class="off"></span><span class="off"></span><span class="on"></span><span v-if="is_discussion == 1" class="off"></span></li>
        <li class="next " v-if="is_discussion == 1"><a style="cursor: pointer;" @click="goPage('next');"><img src="@/assets/img/study_btn_next.png" alt="" border="0"/></a></li>
        <li class="next " v-if="is_discussion == 0">
          <a href="javascript:self.close();"><img src="@/assets/img/study_btn_close.png" alt="" border="0"/></a>
        </li>
      </ul>
    </div>
    <div class="pop_title">
      <p>Quiz</p>
      뉴스에 관한 질문에 답해보세요.<br/>
      로이터 학습의 이해도를 높이며 깔끔하게 마무리 합니다!
    </div>
    <div class="pop_quiz">
      <ul class="pop_quiz_cont" sytle="border-top:0;">
        <li v-if="quizSort === 1" v-for="(item, index) of this.quiz" :key="index" :id="'quiz_check_' + index" class="quiz_check">
          <div class="quiz">
            <div class="num">{{index + 1}}</div>
            <div class="ques">{{ item.QUESTION }}</div>
            <div :class="'anw anw_div' + index">
              <label><input type="text" class="quiz_text" :name="'ans_q_'+index" id="" value=""></label></div>
            <input class="q_answers" type="hidden" :id="'ans_'+index" :name="'ans_'+index" :value="item.ANSWER"/>
            <input type="hidden" :id="'ans_type_'+index" :name="'ans_type_'+index" value="text"/>
          </div>
        </li>
        <li v-if="quizSort !== 1" v-for="(item, index) of this.quiz" :key="index" :id="'quiz_check_' + index" class="quiz_check">
          <div class="quiz">
            <div class="num">{{index + 1}}</div>
            <div class="ques">{{item.QUESTION}}</div>
            <div v-if="item.EXAM1 !== '' && item.EXAM1 !== undefined" :class="'anw anw_div_' + index"><label><input type="radio" class="quiz_radio" :name="'ans_q_' + index" value="1"> a) {{item.EXAM1}}</label></div>
            <div v-if="item.EXAM2 !== '' && item.EXAM2 !== undefined" :class="'anw anw_div_' + index"><label><input type="radio" class="quiz_radio" :name="'ans_q_' + index" value="2"> b) {{item.EXAM2}}</label></div>
            <div v-if="item.EXAM3 !== '' && item.EXAM3 !== undefined" :class="'anw anw_div_' + index"><label><input type="radio" class="quiz_radio" :name="'ans_q_' + index" value="3"> c) {{item.EXAM3}}</label></div>
            <div v-if="item.EXAM4 !== '' && item.EXAM4 !== undefined" :class="'anw anw_div_' + index"><label><input type="radio" class="quiz_radio" :name="'ans_q_' + index" value="4"> d) {{item.EXAM4}}</label></div>
            <input class="q_answers" type="hidden" :id="'ans_' + index" :name="'ans_' + index" :value="item.ANSWER"/>
            <input  type="hidden" :id="'ans_type_' + index" :name="'ans_type_' + index " value="radio"/>
          </div>
        </li>
      </ul>
      <ul class="pop_quiz_btn">
        <a style="cursor: pointer" @click="gocqClear()" class="btn_re">다시풀기</a>
        <a style="cursor: pointer" @click="gocqA()" class="btn_dictate">정답보기</a>
      </ul>
    </div>
  </div>
  <div class="pop_cont" id="content_tab_05" v-if="pageNum === 5">
    <div class="pop_cont_title">
      <ul>
        <li class="prev"><a style="cursor: pointer;" @click="goPage('prev');"><img src="@/assets/img/study_btn_prev.png" alt="" border="0"/></a></li>
        <li class="navi"><span class="off"></span><span class="off"></span><span class="off"></span><span class="off"></span><span class="on"></span></li>
        <li class="next ">
          <a href="javascript:self.close();"><img src="@/assets/img/study_btn_close.png" alt="" border="0"/></a>
        </li>
      </ul>
    </div>
    <div class="pop_title">
      <p>Creative Discussion &amp; Writing</p>
      조금 더 생각해 봅시다!<br>
      아래 질문에 대한 본인의 의견을 이유 및 근거와 함께 논리적으로 말해 보세요!
    </div>
    <div class="pop_discussion">
      <ul class="pop_discussion_cont" sytle="border-top:0;">
        <li  class="quiz_check" v-for="(item, index) of this.discussion" :key="index" style="border-bottom:0px;">
          <div class="quiz">
            <div class="num" style="padding-top: 3px;">{{index+1}}</div>
            <div class="ques">{{item.TITLE}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="pop_btn">
    <ul>
      <a id="trans_btn" style="display:none;" @click="translateView()" class="pop_btn_bottom">
        <span>번역보기</span>
      </a>
    </ul>
    <ul style="padding:0; margin:0;">
      <input type="hidden" id="pageNum" value=""/>
      <li class="next"><a href="javascript:window.scrollTo(0,0);"><img src="@/assets/img/study_btn_top.jpg" alt="" border="0"/></a></li>
    </ul>
  </div>
  <div class="pop_footer">
    &copy; CARROT Global Inc. All right reserved.
  </div>
  <iframe name="ifrm" width="100" height="0" border="0" style="position:absolute; left:-99999999999px;"></iframe>
  <button id="tts" style="position:absolute; left:-99999999999px;"></button>
  </body>
</template>
<script>
import {
  GetUrlParams
} from '@/utils/common.js'
import he from 'he'
import '../../assets/scss/font-awesome.min.css'

export default {
  components: {
    GetUrlParams,
    he
  },
  data: () => ({
    newsSeq: -1,
    seq: -1,
    src: 'email',
    kw: '000003',
    contents: '',
    news: '',
    tabType: 'exp',
    agent: 'pc',
    newsUrl: '',
    expressions: [],
    vocabulary: [],
    pageNum: 1,
    activeDic: [],
    shadowDic: '',
    dictation: '',
    quizSort: -1,
    quiz: [],
    discussion:[],
    is_discussion:0
  }),

  mounted () {
    this.getDailyNews()
    var oParams = GetUrlParams()
    this.seq = oParams.seq
    this.newsSeq = oParams.news_seq
    console.log('seq ', this.seq)
    console.log('newsSeq ', this.newsSeq)
    console.log('userAgent', userAgent)
    let userAgent = window.navigator.userAgent
    if (userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPod') !== -1 || userAgent.indexOf('iPad') !== -1) {
      this.agent = 'ios'
    } else if (userAgent.indexOf('Android') !== -1) {
      this.agent = 'Android'
    } else {
      this.agent = 'pc'
    }
    this.regenerate2()
    //this.getNews()
  },
  methods: {

    getQuiz() {

      var me = this;

      let params = {
        newsSeq: this.newsSeq
        , quizSort: this.quizSort
      }

      this.axios.get('/v1/api/news/quiz', {
        params: params
      }).then(function (res) {
          console.log('getQuiz', res)
          if (res.data.err === 0) {
            me.quiz = res.data.quiz
          } else {
            console.log('문제(퀴즈)가 없나봄')
          }
        }).catch(err => {
        console.log('err', err)
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          me.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },

    goAnswer (type) {
      if (type === 1) {
        $('.ADiv').show()
        var obj = document.getElementsByName('ADiv')
        var len = obj.length
        for (var i = 0; i < len; i++) {
          obj[i].style.display = ''
        }
        $('[name="ans[]"]').hide()
        $('#btn_dictate_a').html('다시풀기')
      } else {
        $('.ADiv').hide()
        var obj = document.getElementsByName('ADiv')
        var len = obj.length
        for (var i = 0; i < len; i++) {
          obj[i].style.display = 'none'
        }
        $('[name="ans[]"]').show()
      }
    },

    translateView () {
      if(this.agent == 'ios') {
        window.location.href = `/cafe/pop_translate?news_seq=${this.newsSeq}`, 'powerguide', 'width=510,height=690';
      }
      else {
        window.open(`/cafe/pop_translate?news_seq=${this.newsSeq}`, 'powerguide', 'width=510,height=690')
      }
    },

    makeDictation (data) {
      let dataArray = data.split(' ')
      let tmpStr = ''

      for (var data of dataArray) {
        if (data.indexOf('&lt;br') !== -1) {
          this.dictation = this.dictation + ' ' + data + ' '
        }

        if (data.indexOf('{') === -1 && data.indexOf('}') === -1) {
          if (tmpStr === '') {
            this.dictation = this.dictation + ' <span>' + data + '</span>'
          } else {
            tmpStr = tmpStr + ' ' + data
          }
        } else {
          if (data.indexOf('{') !== -1 && data.indexOf('}') !== -1) {
            data = data.replace('{', '')
            data = data.replace('}', '')
            this.dictation = this.dictation + ' ' + "<input type='text' name='ans[]' id='ans' class='input' style='border:none; border-bottom:1px solid #efefef;'><span class='ADiv' style='display:none;'><font color='red' style='font-weight:bold;text-decoration:underline;'>" + data.trim() + '</font></span> '
          } else {
            tmpStr = tmpStr + ' ' + data
            if (tmpStr.indexOf('{') !== -1 && tmpStr.indexOf('}') !== -1) {
              tmpStr = tmpStr.replace('{', '')
              tmpStr = tmpStr.replace('}', '')
              this.dictation = this.dictation + ' ' + "<input type='text' name='ans[]' id='ans' class='input' style='border:none; border-bottom:1px solid #efefef;'><span class='ADiv' style='display:none;'><font color='red' style='font-weight:bold;text-decoration:underline;'>" + tmpStr + '</font></span> '
              tmpStr = ''
            }
          }
        }
      }
    },

    makeShadowContents (data) {
      let dataArray = data.split(' ')
      let tmpStr = ''

      for (var data of dataArray) {
        if (data.indexOf('{') === -1 && data.indexOf('}') === -1) {
          if (tmpStr === '') {
            this.shadowDic = this.shadowDic + ' <span>' + data + '</span>'
          } else {
            tmpStr = tmpStr + ' ' + data
          }
        } else {
          if (data.indexOf('{') !== -1 && data.indexOf('}') !== -1) { // 단어
            data = data.replace('{', '')
            data = data.replace('}', '')
            this.shadowDic = this.shadowDic + ' <span><font color="#0072ff"><strong>' + data + '</strong></font></span>'
          } else { // 문장
            tmpStr = tmpStr + ' ' + data

            if (tmpStr.indexOf('{') !== -1 && tmpStr.indexOf('}') !== -1) {
              tmpStr = tmpStr.replace('{', '')
              tmpStr = tmpStr.replace('}', '')
              this.shadowDic = this.shadowDic + ' <span><font color="#f91414"><strong>' + tmpStr + '</strong></font></span>'
              tmpStr = ''
            }
          }
        }
      }
    },

    getDailyNews () {
      var me = this;
      this.axios.get('/v1/api/news/daily', {
      }).then(function (res) {
        me.newsSeq = res.data.newsSeq
        me.getNews();
      }).catch(err => {
        console.log('err', err)
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },

    getNews () {
      var me = this;
      let params = {
        seq: this.seq,
        newsSeq: this.newsSeq
      }
      this.axios.get('/v1/api/news', {
        params: params
      }).then(function (res) {
        console.log('getNews', res)
        if (res.data.err === 0) {
          console.log(res.data.news)
          if(res.data.news.activeDictation !== null) {
            // 띄어쓰기 넣어줘야 문장일 때 같이 안엮어 들어감..
            res.data.news.activeDictation = he.decode(res.data.news.activeDictation)
            me.makeShadowContents(res.data.news.activeDictation.replace(/\r\n/gi, '<br/> '))
            me.makeDictation(res.data.news.activeDictation.replace(/\r\n/gi, '<br/> '))
          }
          me.news = res.data.news
          // 그냥 news에다 넣고 쭈욱 써도 될 듯??
          me.newsUrl = res.data.news.newsurl.replace("http://", "https://");

          me.quizSort = res.data.news.quizSort
          me.checkNews(me.newsUrl)
        }
      }).catch(err => {
        console.log('err', err)
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })

      this.axios.get('/v1/api/news/discussion',{
        params:params
      }).then(res => {
        // console.log(res);
        if(res.data.discussion != null){
          this.discussion = res.data.discussion
          this.is_discussion = 1;
        }else{
          this.is_discussion = 0;
        }
        console.log(this.discussion);
      }).catch(err => {
        console.log('err', err)
          if (err.response.data.path === '/login/msg') {
            alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
            this.$router.push('/login')
          } else {
            alert('관리자에게 문의하세요')
          }
      });
    },

    getVocabulary () {

      var me = this;

      let params = {
        newsSeq: this.newsSeq
      }

      this.axios.get('/v1/api/news/vocabulary', {
        params: params
      }).then(function (res) {
          console.log('getVocabulary', res)
          if (res.data.err === 0) {
            for (var voca of res.data.vocabulary) {
              voca.WORD = he.decode(voca.WORD)
              voca.CONTENT = he.decode(voca.CONTENT).replace(/\r\n/gi, '<br/> ')
            }
            me.vocabulary = res.data.vocabulary
          }
        })
    },

    getExpressions () {

      var me = this;

      let params = {
        newsSeq: this.newsSeq
      }

      this.axios.get('/v1/api/news/expressions', {
        params: params
      }).then(function (res) {
          console.log('getExpressions', res)
          if (res.data.err === 0) {
            for (var expression of res.data.expressions) {
              expression.EXPRESSIONS = he.decode(expression.EXPRESSIONS)
              expression.CONTENT = he.decode(expression.CONTENT).replace(/\r\n/gi, '<br/>')
            }
            me.expressions = res.data.expressions
          }
        })
    },

    checkNews (url) {
      console.log('checkNews ', url)
      var me = this;
      let params = {
        url: url
      }
      this.axios.get('/v1/api/news/check', {
        params: params
      }).then(function (res) {
          console.log('checNews res', res)
          if (res.data.err !== 200) {
            me.newsUrl = 'http://cdn.carrotenglish.com/imooc/err_video.mp4' // 영상오류
          } else {
            if ($('#web_video')[0] !== null || $('#web_video')[0] !== undefined) {
              if ($('#web_video')[0].msZoom === false) {

                $('#web_video')[0].msZoom = true
              }
            }
            ga('set', 'page', '/cafe/pop_news_learn_recommend_page1.php');
            ga('send', 'pageview');
            me.getExpressions()
            me.getVocabulary()
            me.getQuiz()
          }
        })
    },

    doPick (expe, kor_title) {
      var popupWidth = 700
      var popupHeight = 800
      var popupX = (window.screen.width / 2) - (popupWidth / 2)
      var popupY = (window.screen.height / 2) - (popupHeight / 2)
      if(this.agent == 'ios') {
        window.location.href = 'https://imooc.co.kr/pop/reuter_pick?key=' + expe + '&kor_title=' + kor_title, 'P!ck.4.U', 'status=no, height=' + popupHeight + ', width=' + popupWidth + ', left=' + popupX + ', top=' + popupY;
      }
      else {
        window.open('https://imooc.co.kr/pop/reuter_pick?key=' + expe + '&kor_title=' + kor_title, 'P!ck.4.U', 'status=no, height=' + popupHeight + ', width=' + popupWidth + ', left=' + popupX + ', top=' + popupY)
      }
    },

    playtts (word) {
      word = he.decode(word)
      word = word.replace(/(<([^>]+)>)/ig, '')
      word = decodeURI(word)
      var params = {
        text: word,
        voice: 'B' // 목소리 유형 A, B, C, en-US-Wavenet-A
      }
      console.log(params)
      this.axios.get('/v1/api/news/tts', {
        params: params
      }).then(function (res) {
          console.log('tts', res)
          console.log('navigator.appName', navigator.appName)
          if(res.data.err === 200) {
            if (navigator.appName === 'Microsoft Internet Explorer') {
              $('#tts').html('<embed  id="ttsAudio"  height="60" src="' + res.data.data + '" style="display:none"></embed>')
              $('#ttsAudio').trigger('play')
            } else {
              if (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) {
                $('#tts').html('<embed id="html5_play"  type="application/x-mplayer2" pluginspage="http://www.microsoft.com/Windows/MediaPlayer/" src="' + res.data.data + '" autostart="true"  style="display:none">')
              } else {
                $('#tts').html('<audio  id="ttsAudio"  height="60"  style="display:none"><source src="' + res.data.data + '" type="audio/mp3"></source></audio>')
                $('#tts').find('audio').get(0).play()
              }
            }
          } else {
            alert('음성 파일이 없습니다.')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    regenerate () {
      window.location.reload()
    },
    regenerate2 () {
      if (document.layers) {
        setTimeout('window.onresize=regenerate', 450)
      }
    },

    goPage (val) {
      console.log('goPage page : ' + this.pageNum)
      var page = this.pageNum
      if (val === 'next') {
        this.pageNum = this.pageNum + 1
      } else {
        this.pageNum = this.pageNum - 1
      }
      console.log('goPage page : ' + this.pageNum)
      page = this.pageNum

      if (this.pageNum === 1) {
        $('#trans_btn').hide()
        $('.prev').show()
        $('.next').show()

        ga('set', 'page', '/cafe/pop_news_learn_recommend_page1.php')
        ga('send', 'pageview')
      }
      if (this.pageNum === 2) {
        $('#trans_btn').show()
        $('.prev').show()
        $('.next').show()

        ga('set', 'page', '/cafe/pop_news_learn_recommend_page2.php')
        ga('send', 'pageview')
      }
      if (this.pageNum === 3) {
        $('#trans_btn').show()
        $('.prev').show()
        $('.next').show()

        ga('set', 'page', '/cafe/pop_news_learn_recommend_page3.php')
        ga('send', 'pageview')
      }
      if (this.pageNum === 4) {
        $('#content_tab_04').show()
        $('#trans_btn').hide()
        $('.prev').show()
        $('.next').show()

        ga('set', 'page', '/cafe/pop_news_learn_recommend_page4.php')
        ga('send', 'pageview')
      }

      if (this.pageNum === 5) {
        $('#content_tab_05').show()
        $('#trans_btn').hide()
        $('.prev').show()
        $('.next').show()

        ga('set', 'page', '/cafe/pop_news_learn_recommend_page5.php')
        ga('send', 'pageview')
      }
    },

    gocqA () {
      var qLength = $('.q_answers').length

      for (var i = 0; i <= qLength; i++) {
        var ans = $('#ans_' + i).val()
        var type = $('#ans_type_' + i).val()
        var input_ans = ''
        if (type === 'radio') {
          $('input[name="ans_q_' + i + '"]:checked').each(function (pi, po) {
            input_ans = po.value
          })
          // input_ans = $('input[name="ans_q_'+i+'"]').is(':checked').val();
        } else {
          input_ans = $('input[name="ans_q_' + i + '"]').val()
        }

        if (ans === input_ans) {
          $('#quiz_check_' + i).addClass('check_o')
        } else {
          $('#quiz_check_' + i).addClass('check_x')
        }

        if (type === 'radio') {
          $('.anw_div_' + i + ':eq(' + (ans - 1) + ')').css('color', 'red')
        } else {
          $('input[name="ans_q_' + i + '"]').val(ans)
        }
      }
    },

    gocqClear () {
      $('.anw').css('color', 'black')
      $('.quiz_check').removeClass('check_o')
      $('.quiz_check').removeClass('check_x')

      $('.quiz_radio:checked').each(function (pi, po) {
        $(po).attr('checked', false)
      })
      $('.quiz_text').val('')
    }
  }
}
</script>
<!--</body>-->

<style scoped>

@import '../../assets/scss/carrot.css';
@import '../../assets/scss/custom.css';
@import '../../assets/scss/slick.css';
@import '../../assets/scss/lucy.css';
@import '../../assets/scss/reuters_css.css';
/*@import '../../assets/scss/color_scheme-default.css';*/

/*video::-webkit-media-controls {
  overflow: hidden !important
}
video::-webkit-media-controls-enclosure {
  width: calc(100% + 32px);
  margin-left: auto;
}*/
</style>




// WEBPACK FOOTER //
// src/pages/cafe/popNewsLearnRecommendDaily.vue